import b7 from '@/assets/images/banner/banner-7.jpg'
import b8 from '@/assets/images/banner/banner-8.jpg'
import b9 from '@/assets/images/banner/banner-9.jpg'
import b10 from '@/assets/images/banner/banner-10.jpg'
import b11 from '@/assets/images/banner/banner-11.jpg'
import b20 from '@/assets/images/banner/banner-20.jpg'
import left from '@/assets/images/elements/decore-left.png'
import right from '@/assets/images/elements/decore-right.png'
import en from '@/assets/images/flags/en.png'
import es from '@/assets/images/flags/es.png'
import advertencia2 from '@/assets/images/logo/advertencia2.jpeg'
import advertencia2En from '@/assets/images/logo/advertencia2En.jpg'
import ipspINC from '@/assets/images/logo/conn111.png'
import oriental from '@/assets/images/logo/oriental.png'
import error2 from '@/assets/images/logo/error2.jpeg'
import error2En from '@/assets/images/logo/error2En.jpg'
import ipsplogo from '@/assets/images/logo/ipsp_logo.jpg'
import logo_asia from '@/assets/images/logo/logo_asia.png'
import i1024 from '@/assets/images/logo/logo-1024.png'
import i1024b from '@/assets/images/logo/logo-1024b.png'
import spmemo from '@/assets/images/logo/logo-sp-memo.png'
import logo2 from '@/assets/images/logo/logo2.png'
import logo2b from '@/assets/images/logo/logo2b.png'
import appLogoImage from '@/assets/images/logo/logo3.png'
import logo7r from '@/assets/images/logo/logo7_reporte.png'
import ilogo7 from '@/assets/images/logo/logo7.png'
import ilogo7b from '@/assets/images/logo/logo7b.png'
import logoEtiqueta from '@/assets/images/logo/logoEtiqueta.png'
import logoSP from '@/assets/images/logo/logoSP.png'
import logoSPnslogan from '@/assets/images/logo/logoSPnslogan.png'
import logow from '@/assets/images/logo/logow.png'
import salem2 from '@/assets/images/logo/salem2.png'
import tropackLogo from '@/assets/images/logo/tropackLogo.png'
import asistencia_falta from '@/assets/images/pages/controlCostos/asistencia_falta.jpeg'
import buscar_empleados from '@/assets/images/pages/controlCostos/buscar_empleados.jpeg'
import empleados from '@/assets/images/pages/controlCostos/empleados.jpeg'
import seleccionar_empleados from '@/assets/images/pages/controlCostos/seleccionar_empleados.jpeg'
import submotivo from '@/assets/images/pages/controlCostos/submotivo.jpeg'
import errord from '@/assets/images/pages/error-dark.svg'
import error from '@/assets/images/pages/error.svg'
import sideImg from '@/assets/images/pages/login-v2.svg'
import notauthd from '@/assets/images/pages/not-authorized-dark.svg'
import notauth from '@/assets/images/pages/not-authorized.svg'
import qr from '@/assets/images/sign/qr.png'
import mision from '@/assets/images/slider/mision.jpg'
import valores from '@/assets/images/slider/valores.jpg'
import vision from '@/assets/images/slider/vision.jpg'
import i2x from 'leaflet/dist/images/marker-icon-2x.png'
import mi from 'leaflet/dist/images/marker-icon.png'
import ms from 'leaflet/dist/images/marker-shadow.png'

// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
    app: {
        appName: '', // Will update name in navigation menu (Branding)
        // eslint-disable-next-line global-require
        appLogoImage, // Will update logo in navigation menu (Branding)
        appLogoNavB: ilogo7b, // Dark
        appLogoNav: ilogo7, // Light
    },
    layout: {
        isRTL: false,
        skin: 'semi-dark', // light, dark, bordered, semi-dark
        theme: 'light', // light, dark
        routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
        type: 'vertical', // vertical, horizontal
        contentWidth: 'full', // full, boxed
        width: 300,
        menu: {
            hidden: false,
            isCollapsed: false,
        },
        navbar: {
            // ? For horizontal menu, navbar type will work for navMenu type
            type: 'floating', // static , sticky , floating, hidden
            backgroundColor: '', // BS color options [primary, success, etc]
        },
        footer: {
            type: 'static', // static, sticky, hidden
        },
        customizer: false,
        enableScrollToTop: true,
    },
    // Images Assets
    logos: {
        i1024,
        i1024b,
        ilogo7b,
        ilogo7,
        sideImg,
        logoSP,
        tropackLogo,
        logoEtiqueta,
        salem2,
        logow,
        spmemo,
        ipsplogo,
        logo7r,
        error,
        errord,
        error2,
        error2En,
        notauth,
        notauthd,
        advertencia2,
        advertencia2En,
        logo_asia,
        logoSPnslogan,
        logo2,
        logo2b,
        ipspINC,
        oriental,
    },
    flags: {
        es,
        en,
    },
    decore: {
        left,
        right,
    },
    leaflet: {
        i2x,
        mi,
        ms,
    },
    banners: {
        b20,
        b7,
        b8,
        b9,
        b10,
        b11,
    },
    rrhh: {
        mision,
        vision,
        valores,
    },
    cc: {
        asistencia_falta,
        submotivo,
        empleados,
        buscar_empleados,
        seleccionar_empleados,
    },
    sign: {
        qr,
    },
}
